<div class="bl-padding-sm--24 bl-text-align--center">
    <div class="bl-max-width--100 bl-margin-x--auto bl-margin-bottom--24">
        <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="60" cy="60" r="60" fill="#FFF7E1" />
            <path
                d="M92.55 82.9976L65.0351 31.1514C64.5194 30.1673 63.7442 29.3431 62.7935 28.768C61.8429 28.1929 60.753 27.8889 59.6419 27.8889C58.5308 27.8889 57.441 28.1929 56.4903 28.768C55.5396 29.3431 54.7645 30.1673 54.2487 31.1514L26.7338 82.9976C26.2254 83.9476 25.9733 85.0136 26.0022 86.0907C26.0312 87.1678 26.3403 88.2187 26.899 89.14C27.4371 90.0472 28.2025 90.7983 29.1196 91.3194C30.0367 91.8404 31.0738 92.1133 32.1285 92.1111H87.1553C88.21 92.1133 89.2471 91.8404 90.1642 91.3194C91.0813 90.7983 91.8467 90.0472 92.3848 89.14C92.9436 88.2187 93.2526 87.1678 93.2816 86.0907C93.3105 85.0136 93.0584 83.9476 92.55 82.9976Z"
                fill="#F7BF26" />
            <path d="M63.1366 47.7667L61.3888 73.1057H57.8933L56.1455 47.7667H63.1366Z" fill="#363636" />
            <path
                d="M59.6435 85.9942C62.177 85.9942 64.2308 83.9404 64.2308 81.4069C64.2308 78.8733 62.177 76.8195 59.6435 76.8195C57.11 76.8195 55.0562 78.8733 55.0562 81.4069C55.0562 83.9404 57.11 85.9942 59.6435 85.9942Z"
                fill="#363636" />
        </svg>
    </div>
    <h4 class="bl-font-size--base bl-font-color--steel bl-font-weight--900 bl-margin-bottom--16">
        {{'confirmLeave/heading' | dictionary}}
    </h4>
    <p class="bl-font-color--slate bl-margin-bottom--24">
        {{'confirmLeave/description' | dictionary}}
    </p>
    <div
        class="bl-display--block bl-display-sm--flex bl-flex-direction--row-reverse bl-justify-content--center bl-width-sm--75 bl-margin-x--auto bl-margin-top--32">
        <button type="button" id="changeMembership"
            (click)="continueClicked(false)"
            class="bl-button bl-width--100 bl-margin-bottom--16 bl-margin-bottom-sm--0">{{'confirmLeave/stay' | dictionary}}</button>
        <button type="button" id="custom-modal-close"
            (click)="continueClicked(true)"
            class="bl-button bl-button-reverse bl-margin-right--24 bl-width--100">{{'confirmLeave/leave' | dictionary}}</button>
    </div>
</div>